import { HttpClient, HttpContext } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { SizeGuide } from "@hermes/api-model-product";
import { LOCALE, Settings } from "@hermes/app-core";
import { Locale } from "@hermes/locale";
import { SKIP_404_INTERCEPTOR } from "@hermes/utils/constants";

@Injectable()
export class SizeGuideService {
    constructor(
        private http: HttpClient,
        private settings: Settings,
        @Inject(LOCALE) private locale: Locale,
    ) {}

    public getSizeGuide(sizeGuideId: string): Observable<SizeGuide> {
        const context = new HttpContext().set(SKIP_404_INTERCEPTOR, true);
        return this.http.get<SizeGuide>(
            `${this.settings.apiUrl}/product/size-guide/${sizeGuideId}`,

            {
                context,
            },
        );
    }
}
